// src/pages/admin/AdminSetup.js
//
// Página que se llama UNA VEZ tras el deploy inicial para crear:
//   · Los 4 roles Identity (SUPERADMIN, ADMIN_NEGOCIO, VECI, DOMICILIARIO)
//   · El primer SuperAdmin (con las credenciales de appsettings)
//
// Después de esto, el superadmin ya puede loguearse en /login y entrar a /admin.
// No está enlazada en el menú lateral — accede directo por /admin/setup.

import React, { useState } from 'react';
import {
  Box, Container, Card, CardContent, Typography, Button, Stack, Alert, Divider,
} from '@mui/material';
import { admin } from '../../api/authApi';
import { useNavigate } from 'react-router-dom';

export default function AdminSetup() {
  const [rolesRes, setRolesRes] = useState(null);
  const [saRes, setSaRes]       = useState(null);
  const [error, setError]       = useState('');
  const [cargando, setCargando] = useState(false);
  const navigate = useNavigate();

  const crearRoles = async () => {
    setError(''); setCargando(true);
    try { setRolesRes(await admin.initRoles()); }
    catch (e) { setError(e.mensajeUsuario || 'No se pudieron crear los roles.'); }
    finally  { setCargando(false); }
  };

  const crearSA = async () => {
    setError(''); setCargando(true);
    try { setSaRes(await admin.initSuperAdmin()); }
    catch (e) { setError(e.mensajeUsuario || 'No se pudo crear el SuperAdmin.'); }
    finally  { setCargando(false); }
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#F8F5EF', py: 6 }}>
      <Container maxWidth="sm">
        <Card>
          <CardContent sx={{ p: 4 }}>
            <Typography variant="overline" color="text.secondary">HolaVeci · Setup inicial</Typography>
            <Typography variant="h4" sx={{ fontFamily: 'Fraunces', mb: 2 }}>
              Configuración de la plataforma
            </Typography>
            <Typography color="text.secondary" sx={{ mb: 3 }}>
              Esta página se corre una única vez tras el primer despliegue. Crea los roles del
              sistema y el primer SuperAdmin (con las credenciales definidas en
              <code style={{ margin: '0 4px' }}>appsettings.Development.json</code>).
            </Typography>

            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

            <Stack spacing={2}>
              <Box>
                <Button variant="contained" onClick={crearRoles} disabled={cargando} fullWidth>
                  1. Crear roles
                </Button>
                {rolesRes && (
                  <Alert severity="success" sx={{ mt: 1 }}>
                    Roles creados: {rolesRes.creados?.join(', ') || '(ninguno)'}<br />
                    Ya existentes:  {rolesRes.existentes?.join(', ') || '(ninguno)'}
                  </Alert>
                )}
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                  Si es la primera vez, córrelo. Si ya lo corriste antes (o los roles ya existen), puedes saltarlo.
                </Typography>
              </Box>

              <Divider />

              <Box>
                <Button variant="contained" color="warning" onClick={crearSA}
                        disabled={cargando} fullWidth>
                  2. Crear SuperAdmin
                </Button>
                {saRes && (
                  <Alert severity="success" sx={{ mt: 1 }}>
                    {saRes.mensaje}<br />
                    Correo: <b>{saRes.correo}</b>
                  </Alert>
                )}
              </Box>

              {saRes && (
                <Button variant="outlined" onClick={() => navigate('/login')}>
                  Ir al login
                </Button>
              )}
            </Stack>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
}
